var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2, _circle3, _circle4, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 243,
    viewBox: "0 0 228 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1888_39348)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.191,
    cy: 121.395,
    rx: 73.5,
    ry: 80.8922,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.191 121.395C187.191 165.84 154.464 201.787 114.191 201.787C73.9181 201.787 41.1909 165.84 41.1909 121.395C41.1909 76.9494 73.9181 41.0028 114.191 41.0028C154.464 41.0028 187.191 76.9494 187.191 121.395Z",
    stroke: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190.691 67.5C182.573 64.5494 166.327 82.6568 160.673 86.5C160.674 86.5018 160.678 86.5107 160.685 86.5264C161.136 87.5409 174.111 117.17 178.31 131.692C178.379 131.933 178.446 132.169 178.511 132.401C189.2 104.03 197.867 83.5301 197.191 77.5C197.191 71.5 192.876 68.2945 190.691 67.5Z",
    fill: "#FFFF38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.226 177.888C105.212 177.792 104.114 177.688 102.883 177.582C99.6469 188.02 88.6931 208.891 70.7615 208.891C63.0671 208.891 55.4866 206.181 50.7073 200.716C42.2761 192.772 40.348 175.978 43.0268 156.08C53.2755 155.935 60.507 148.672 66.275 129.099L60.358 99.8843C62.5674 94.6125 64.0293 91.1093 64.5188 89.9353C64.6404 89.6437 64.7702 89.3582 64.9098 89.0749L65.8479 87.1712C76.2206 66.4479 88.9475 48.355 101.899 38.4236C108.472 34.2898 118.458 33.4472 124.949 38.4236C137.765 48.2518 150.371 66.073 160.685 86.5264C161.136 87.5409 174.111 117.17 178.31 131.692L178.511 132.401C186.803 162.175 187.856 189.685 176.149 200.716C171.37 206.181 163.789 208.891 156.095 208.891C138.162 208.891 127.208 188.017 123.973 177.58C114.987 178.72 111.961 178.433 106.226 177.888Z",
    fill: "#FFFF38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1485 118.677L57.7707 106.152C58.6761 103.918 59.551 101.81 60.358 99.8843L66.275 129.099C59.6912 146 52.651 153.455 43.7061 153.5C44.766 146.35 46.4012 138.832 48.5264 131.202L53.1485 118.677Z",
    fill: "#FFFF38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1043 146.234C35.0926 151.884 40.348 153.517 43.7061 153.5C44.766 146.35 46.4012 138.832 48.5264 131.202L53.1485 118.677L57.7707 106.152C58.6761 103.918 59.551 101.81 60.358 99.8843C41.9268 109.104 33.7377 135.032 34.1043 146.234Z",
    fill: "#FFFF38"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1101 149.108C35.3345 152.577 37.3956 154.702 40.5666 155.734C41.3587 155.992 42.1939 156.092 43.0268 156.08C43.1146 155.428 43.6086 154.158 43.7061 153.5C40.348 153.517 35.0926 151.884 34.1043 146.234C34.1295 147.004 33.8537 148.381 34.1101 149.108Z",
    fill: "#ACAC22"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0268 156.08C53.2755 155.935 60.507 148.672 66.275 129.099C59.6912 146 52.651 153.455 43.7061 153.5C43.6086 154.158 43.1146 155.428 43.0268 156.08Z",
    fill: "#ACAC22"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M174.195 120.119L170.051 109.159C169.068 106.794 171.964 112.649 171.028 110.55C174.528 117.05 179.528 124.05 180.528 127.05L178.528 132.55L174.195 120.119Z",
    fill: "#ACAC22"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M107.69 107.738C109.145 109.399 113.581 111.725 119.69 107.738",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.69 86.7266H118.69",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 133.69,
    cy: 87,
    r: 5,
    fill: "black",
    stroke: "black",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.6909,
    cy: 87,
    r: 5,
    fill: "black",
    stroke: "black",
    strokeWidth: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2,
    transform: "matrix(1 0 0 -1 132.69 87)",
    fill: "white",
    stroke: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2,
    transform: "matrix(1 0 0 -1 92.6904 87)",
    fill: "white",
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.458 85.5C108.458 98.7204 97.4638 109.5 83.8243 109.5C70.1847 109.5 59.1909 98.7204 59.1909 85.5C59.1909 72.2796 70.1847 61.5 83.8243 61.5C97.4638 61.5 108.458 72.2796 108.458 85.5ZM168.191 85.5C168.191 98.7204 157.197 109.5 143.558 109.5C129.918 109.5 118.924 98.7204 118.924 85.5C118.924 72.2796 129.918 61.5 143.558 61.5C157.197 61.5 168.191 72.2796 168.191 85.5Z",
    fill: "#D9D9D9",
    fillOpacity: 0.25,
    stroke: "black",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6621 176.66C93.6621 176.66 98.007 177.102 103.255 177.581C102.913 178.662 102.513 179.857 102.005 181.126L93.6621 176.66Z",
    fill: "#ACAC22"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M132.9 176.66C132.9 176.66 128.555 177.102 123.307 177.581C123.649 178.662 124.049 179.857 124.557 181.126L132.9 176.66Z",
    fill: "#ACAC22"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1888_39348",
    x: 0.690918,
    y: 0.502808,
    width: 227,
    height: 241.784,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_1888_39348"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar2);
export default __webpack_public_path__ + "static/media/star2.fbeffa080a8b06f7fb6543f6e57209dc.svg";
export { ForwardRef as ReactComponent };